import { axios, Response } from '../index'

export interface Body {
  cpf: string
  email: string
  accessProfileIds: string[]
  name: string
  lastName: string
}

const createTherapist = (body: Body): Response<null> => {
  return axios.post('/v1/therapists', body)
}

export default createTherapist
